'use strict';

const $ = require('jquery');
const lang = require('../lang');
const Slide = require('./slide');
const template = require('../templates/breathalyzer-slide.hbs');

module.exports = class extends Slide {
  constructor(context = {}) {
    context = $.extend({}, {title: lang.get('breathalyzer_title') }, context);
    super(template, context);
    this._idletimer = _idletimer;
    this.on('beforeEnter', this._storeBreathalyzerData);
    this.on('beforeEnter', this._delayNextButton);
    this.on('afterEnter', this._stopIdleTimer);
  }

  reset() {

  }

  _storeBreathalyzerData() {
    const trackId = this._slideshow.getTrackId();
    var main_loc_id = localStorage.getItem("main_location_id") || 0;
    var uin = localStorage.getItem("unique_identification_number") || '';
    $.ajax({
      method: 'POST',
      url: 'slideshow/brethalyzersign',
      data: $.extend({}, this._slideshow.getFormData(), {
        subLocationId: this._slideshow.getSublocationId(),
        trackId: trackId,
        readSlideshow: !this._slideshow.hasSkipped,
        main_location_id: main_loc_id,
        unique_identification_number: uin
      }),
      success:function (res){
        if(res != 0){
          $('#approval_id').val(res);
        }
      },
    });
  }

  _delayNextButton() {
    $('#breathalyzer-ok').hide();
    $('#breathalyzer-idle').show();
    $('#breathalyzer-ok-text').hide();
    $('#breathalyzer-idle-text').show();
    $('#breathalyzer-slide-next-button').attr("disabled", true);
    $('#breathalyzer-slide-next-button').removeAttr("data-nav-next", false);
    $('#breathalyzer-slide-next-button').removeAttr("href", false);
    $('#breathalyzer-slide-cancel-button').attr("disabled", true);
    $('#breathalyzer-slide-cancel-button').removeAttr("data-nav-cancel", false);
    $('#breathalyzer-slide-cancel-button').removeAttr("href", false);
    this._intervalHandler = setInterval(() => {
        var id = $("#approval_id").val();
        if(id == '' || id == null){
        return false;
        }
        $.ajax({
        type: "GET",
        async: true,
        cache: false,
        data: {'id':id},
        url:  'slideshow/get-brethalyzersign',
          success: (result)=>{
            if(result=='success'){
              $('#breathalyzer-ok').show();
              $('#breathalyzer-idle').hide();
              $('#breathalyzer-ok-text').show();
              $('#breathalyzer-idle-text').hide();
              $('#breathalyzer-slide-next-button').removeAttr("disabled", false);
              $('#breathalyzer-slide-next-button').attr("data-nav-next", true);
              $('#breathalyzer-slide-next-button').attr("href", "#");
              $('#breathalyzer-slide-cancel-button').removeAttr("disabled", false);
              $('#breathalyzer-slide-cancel-button').attr("data-nav-cancel", true);
              $('#breathalyzer-slide-cancel-button').attr("href", "#");
              $("#approval_id").val("");
              localStorage.setItem("breathalyzer_check","1");
            }
          }
        });

    }, 10000);
  }

  _passBreathalyzer(e) {

      $('#breathalyzer-ok').show();
      $('#breathalyzer-idle').hide();
      $('#breathalyzer-ok-text').hide();
      $('#breathalyzer-idle-text').show();
      $('#breathalyzer-slide-next-button').removeAttr("disabled", false);
      $('#breathalyzer-slide-next-button').attr("data-nav-next", true);
      $('#breathalyzer-slide-next-button').attr("href", "#");
      $('#breathalyzer-slide-cancel-button').removeAttr("disabled", false);
      $('#breathalyzer-slide-cancel-button').attr("data-nav-cancel", true);
      $('#breathalyzer-slide-cancel-button').attr("href", "#");

  }

  _stopIdleTimer(){
    if(_idleintervalHandler != undefined){
      clearInterval(_idleintervalHandler);
    }
  }
};
